import { tools } from '@/utils/tools';
import { fieldTypeAggregation } from './contants';

// 是否支持汇总
export function isAggregationField(fieldType, fieldExt) {
  return !!getAggregationList(fieldType, fieldExt);
}

// 获取汇总类型列表
export function getAggregationList(fieldType, fieldExt) {
  if (fieldType === 24) {
    const { success, result } = tools.safeParseJson(fieldExt);
    if (success) {
      return fieldTypeAggregation[fieldType][result.type];
    }
    return null;
  }
  return fieldTypeAggregation[fieldType];
}
